var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFacilityMeetingRoom = function SvgFacilityMeetingRoom(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.7116565,29.4892916 L58.0132464,2.47116969 C53.3569321,-0.823723229 47.4589339,-0.823723229 42.8026196,2.47116969 L7.41463053,29.4892916 C5.24168383,31.1367381 4,33.4431631 4,36.0790774 C4,40.6919275 7.41463053,44.3163097 11.7605239,44.3163097 L14.2438915,44.3163097 L14.2438915,86.16145 C14.2438915,93.7397036 20.1418897,100 27.2815718,100 L73.5342943,100 C80.6739765,100 86.5719743,93.7397036 86.5719743,86.16145 L86.5719743,44.645799 L89.0553418,44.645799 C91.5387101,44.645799 94.0220776,43.3278419 95.2637614,41.0214168 C98.0575501,37.3970346 97.4367078,32.1252059 93.7116565,29.4892916 Z M47,76 C47,79.1578948 44.4736842,82 41,82 L35,82 C31.8421053,82 29,79.4736843 29,76 L29,70 C29,66.8421052 31.5263158,64 35,64 L41,64 C44.1578947,64 47,66.5263158 47,70 L47,76 Z M72,76 C72,79.1578948 69.4736842,82 66,82 L60,82 C56.8421053,82 54,79.4736843 54,76 L54,70 C54,66.8421052 56.5263158,64 60,64 L66,64 C69.1578947,64 72,66.5263158 72,70 L72,76 Z M72,51 C72,54.1578947 69.4736842,57 66,57 L60,57 C56.8421053,57 54,54.4736842 54,51 L54,45 C54,41.8421053 56.5263158,39 60,39 L66,39 C69.1578947,39 72,41.5263158 72,45 L72,51 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFacilityMeetingRoom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "facility-meeting-room.be9611bf642f38f946ff465cd6f97fa2.svg";